import { useState } from 'react';
import type { BoardContextValue } from '../board/useBoardContext';
import { AiTabbedModal } from '../board/ai';
import { SparkleIcon } from './icons';
import '@/styles/ai.css';

export interface AiAssistantProps {
  context: BoardContextValue;
  /** Callback khi import câu hỏi thành công - báo kết quả cho vỏ bảng */
  onOpenLibrary?: (highlightIds: string[], openedOnBoard: boolean) => void;
}

// bottom-left of the canvas; it rides above the keyboard inset so the thumb never loses it
export function AiAssistant({ context, onOpenLibrary }: AiAssistantProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="ai-fab-slot">
      <button
        type="button"
        className="ai-fab"
        aria-label="Trợ lý AI"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <SparkleIcon size={22} />
      </button>
      <AiTabbedModal open={open} context={context} onClose={() => setOpen(false)} onImportSuccess={onOpenLibrary} />
    </div>
  );
}
